import { createApiRef } from '@backstage/core-plugin-api';

import { AzureResourcesApi } from './AzureResourcesApi';
import { AzureResourcesClient } from './AzureResourcesClient';

export {
  armApiRef,
  ArmApiClient,
  groupDeserializer,
  type Group,
  type GetGroupsParams,
} from './ArmApiClient';

export {
  armTagsApiRef,
  ArmTagsClient,
  ArmRequestError,
  grantsTagWrite,
  isSafeResourceGroupName,
  tagKeyCasings,
  type ArmTagsApi,
  type ResolvedResourceGroup,
  type TagValueSuggestion,
  type TagWriteAccess,
} from './ArmTagsClient';

export const azureResourcesApiRef = createApiRef<AzureResourcesApi>({
  id: 'azure-resources',
});

export { type AzureResourcesApi, AzureResourcesClient };
